import { render } from "./RegistrationInput.vue?vue&type=template&id=40d416d2"
import script from "./RegistrationInput.vue?vue&type=script&lang=js"
export * from "./RegistrationInput.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__